module.exports = __webpack_public_path__ + "img/1.10a569c9.png";